import { limitByPage } from '../utils/infinitScroll';
import instances from './map';
import { generateToken_ME } from './generateToken';


const getTreatmentsByStatus = ({ keyword, offset, limit, creden }) =>
  instances
    .procedimentov2({
      method: 'GET',
      url: `/credenciados/${creden}/paciente?keyword=${keyword}&limit=${limit}&offset=${offset}`
    })
    .then(res => res.data.data)
    .catch(err => {
      if (err.response.status && err.response.status === 404) {
        if (err.response.data.message && err.response.data.message.code === 1404) {
          // todos os planos foram carregados
        }
        return [];
      }

      console.error(err.message);
      return Promise.reject(new Error('Não foi possível trazer a lista de pacientes'));
    });

let canRequestTreatmentPlan = true;
export const getPatientWithGTO = async ({ creden, keyword, page }) => {
  if (!canRequestTreatmentPlan) return;
  canRequestTreatmentPlan = false;

  await generateToken_ME('procedimento_ME');

  const offset = page;
  const limit = limitByPage;

  return Promise.all([getTreatmentsByStatus({ keyword, offset, limit, creden })])
    .then(([OPEN]) => ({ OPEN }))
    .catch(err => Promise.reject(new Error(err.message)))
    .finally(() => (canRequestTreatmentPlan = true));
};

export default {
  getPatientWithGTO
};
